export const DATE_GROUPINGS = [
  {
    text: 'None',
    value: 'none',
  },
  {
    text: 'Day',
    value: 'day',
  },
  {
    text: 'Week',
    value: 'week',
  },
  {
    text: 'Month',
    value: 'month',
  },
  {
    text: 'Quarter',
    value: 'quarter',
  },
  {
    text: 'Year',
    value: 'year',
  },
];

export const METRIC_COLUMNS = [
  { text: 'Conversions', value: 'conversions' },
  { text: 'Revenue', value: 'revenue' },
  { text: 'Spend', value: 'spend' },
  { text: 'CPA', value: 'cpa' },
  { text: 'ROAS', value: 'roas' },
];

export const FREQUENCY_OPTIONS = [
  { text: 'Never', value: 'never' },
  { text: 'Daily', value: 'day' },
  { text: 'Weekly', value: 'week' },
  { text: 'Monthly', value: 'month' },
];

export const RECURRING_EXPORT_DATE_OPTIONS = [
  { text: 'Monday', value: 'monday' },
  { text: 'Tuesday', value: 'tuesday' },
  { text: 'Wednesday', value: 'wednesday' },
  { text: 'Thursday', value: 'thursday' },
  { text: 'Friday', value: 'friday' },
  { text: 'Saturday', value: 'saturday' },
  { text: 'Sunday', value: 'sunday' },
];
